import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import Components from 'components';
import Plugins from 'plugins';
import { CountUp } from 'countup.js';

// Initialise Alpine
window.Alpine = Alpine;
Alpine.plugin(collapse);
Alpine.start();

// block specific scripts (see /blocks/block.example.js)
// e.g. import "blocks/hero/hero001"

import "blocks/OTHE/OTHELocationMap";

jQuery(function($) {
    Components.init();
    Plugins.init();

    if( $('#herovideo-slider').length ) {
        $('#herovideo-slider').slick({
            arrows: false,
            adaptiveHeight: false,
            dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            appendDots: '.hero-dots',
            autoplay: true,
            autoplaySpeed: 8000,
            pauseOnHover: false,
            fade: true,
            customPaging: function(slider, i) {
                let label = $(slider.$slides[i]).find('li').data('label');
                return '<button><span><span></span></span>'+label+'</button>';
            },
        })
    }

    if( $('.scrolling-text').length ) {
        $('.scrolling-text > strong').each(function() {
            let scroller = $(this);
            let first = scroller.find('span').first();
            first.addClass('active').addClass('start');

            setInterval(function() {
                let current = scroller.find('span.current, span.first');
                let next = current.next();
                if ( !next.length ) next = first;

                if ( next.width() > scroller.width() ) scroller.width(next.width());

                current.removeClass('current').removeClass('start');
                next.addClass('active').addClass('current');
            }, 2000);
        })
    }

    if($('#input_5_19_1').length) {
        $('#input_5_19_1').attr('checked', true);
    }

    if($('.countup').length) {
        $('.countup').each(function(i) {
            let format = $(this).hasClass('format');
            let count = new CountUp($(this).attr('id'), $(this).attr('data-count'), {
                enableScrollSpy: true,
                separator: (format ? ',' : '')
            });
        });
    }
});